import { Component, HostListener, OnInit } from '@angular/core';

import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IoBasculaService } from '../../services/general-services/iobascula.services';
import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { PlantaService } from '../../services/general-services/planta.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { LineaService } from '../../services/general-services/linea.service';
import { BasculasCapturador, BasculasPersonas } from '../../models/basculaPlanta';
import { DatoDataArea } from '../../models/diccionarioTvcInterface';


@Component({
  selector: 'app-capturador-peso',
  templateUrl: './capturador-peso.component.html',
  styleUrls: ['./capturador-peso.component.css']
})

export class CapturadorPesoComponent implements OnInit {

  constantesDelModulo = moduloPerform;
  
  public DAT_TITULOS  : any = this.constantesDelModulo.titulos.capturardora;
  public DAT_BTNS     : any = this.constantesDelModulo.button.buttonsNombre;
  public DAT_BTNCSS   : any = this.constantesDelModulo.button.buttonsCss;
  public DAT_MSG      : any = this.constantesDelModulo.mensajes;
  public DAT_AG_GRID  : any = this.constantesDelModulo.agGrid;

  public columnDefs     : any[] = [];
  public rowData        : any[] = [];
  public gridApi        : any;
  public gridColumnApi  : any;
  public frameworkComponents: any;

  public loading        : boolean = false;
  public isCreate       : boolean;
  public tituloModal    : string;
  public urlProducto    : string;

  public plantaSelected : BasculasPersonas;
  public pesoCapturado  : BasculasCapturador;
  public lastPesajeDia  : BasculasCapturador;
  public listDataGrafico: DatoDataArea[] = [];
  
  public lineaSelected;
  autoSaveInterval  : any;
  cmbPlanta         : BasculasPersonas[] = [];

  listLineas        : any[] = [];
  valorCaptura      : Number = 0.00;


  get planta() {
    return this.formPlanta.get('plantaId');
  }

  public formPlanta = new FormGroup({
    plantaId  : new FormControl('' , Validators.required),
  });

  public formCaptura = new FormGroup({
    plantaId  : new FormControl('', Validators.required),
    lineaId   : new FormControl('', Validators.required),
    pesaje    : new FormControl('', Validators.required),
    creadoPor : new FormControl(localStorage.getItem('userName'), [Validators.required]),
  });

  constructor(
    private _util: UtilsService, 
    private _basculasIoAPI: IoBasculaService,
    private _plantaAPI    : PlantaService,
    private _dmaestrosApi : DatosMaestrosService,
    private _commonForm   : CommonFormService,
    private _lineaAPI     : LineaService
  ) { }

  ngOnInit(): void {
    this.getAllPlantaByUser();

    this.formCaptura.get('pesaje').valueChanges.subscribe((resp) => {
      if(resp) this.valorCaptura = resp;
    });

  }

  getAllPlantaByUser() {
    this.cmbPlanta = [];

    this._basculasIoAPI.personaBascula(localStorage.getItem('userName')).subscribe((res: any) => {
      this.cmbPlanta = res;
    }, (err) => {
      console.log('err',err);
      this._util.mensajeErroToast("No se encontro Plantas asignadas a su usuario, por favor contacte al administrador ",3000);
    });

  }

  cambiarPlanta() {
    this.isCreate     = true;
    this.tituloModal  = "Seleccione planta para recargar Lineas";
    this.resetControl();
    this.openModal();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    
    const planta = this.planta.value;
    this.plantaSelected = this.cmbPlanta.find((e) => e.plantaId === planta);
    this.getLineasXPlanta();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  getPlantaSelected() {
  }

  getLineasXPlanta() {
    const planta = this.plantaSelected.plantaId;
    this.loading = true;

    this._lineaAPI.lineasByCodigoPlantaActiva(planta).subscribe((res: any[]) => {
      this.listLineas = res;
      this.resetControl();
      this.closeModal();
    }, (err) => {
      this._util.mensajeErroToast("No se ha podido cargar las líneas de la planta");
      console.log(err);
    });
    this.loading = false;
  }

  // selecciona Linea para planta
  selecionLinea(item: any): void {
    this.resetControl();
    this.lineaSelected =[];
    this.listDataGrafico =[];
    
    this.formCaptura.get('creadoPor').setValue(localStorage.getItem('userName'));
    this.formCaptura.get('plantaId').setValue(this.plantaSelected.plantaId);
    this.formCaptura.get('lineaId').setValue(item.id);
    
    this.lineaSelected = item;
    this.consultarReporteParada();
  }

  consultarReporteParada(){
    this.loading = true;
    this.rowData = [];
    this.getLastPesaje();

    this._plantaAPI.getReporteElectricista(this.plantaSelected.plantaId).subscribe((reporteElectricista: any) => {
      console.info("***** Consultando reporte/electrisista/", reporteElectricista);
      this.rowData =  reporteElectricista.respuesta.find((e) => e.idLinea === this.lineaSelected.id);

      if(this.rowData != undefined){
        this.mappinDetalle();
        this.getRegistros();
        console.info("El evento actual", this.rowData);
      }
      this.loading = false;
    }, (error) => {
      console.log(error);
      this.loading = false;
    });

  }

  detalleEvento: { etiqueta: string; valor: string }[] = [];
  mappinDetalle(){
    const ahora  = new Date();

    console.log("row data", this.rowData, this.rowData['nombreProducto']);
    if(this.rowData['nombreProducto'] == undefined) this._util.mensajeErroToast("No existe material para procesar");
    this.urlProducto = null;
    this.urlProducto = this._util.getImagenPin(this.rowData['idProducto']);
    console.log("imagen url", this.urlProducto );
    
    this.detalleEvento = [
      { etiqueta: 'PLANTA',       valor: this.plantaSelected.plantaId +" - " +this.plantaSelected.nombre},
      { etiqueta: 'LINEA',        valor: this.rowData['nombreLinea'] },
      { etiqueta: 'COD_MATERIAL', valor: this.rowData['idProducto'] },
      { etiqueta: 'MATERIAL',     valor: this.rowData['nombreProducto']},
      { etiqueta: 'LOTE',         valor: this.rowData['noLote'] },
      { etiqueta: 'ORDEN DE PRODUCCION', valor: this.rowData['ordenProduccion'] },
      { etiqueta: 'TURNO',        valor: this.rowData['turno'] },
      { etiqueta: 'FECHA_PESAJE', valor: ahora.toLocaleDateString() },
      { etiqueta: 'HORA FABRIL',  valor: ahora.toLocaleTimeString() },
      { etiqueta: 'COD. EVENTO',  valor: this.rowData['codigoEvento'] + " - " + this.rowData['nombreEvento'] },
      { etiqueta: 'BALANZA',      valor: this.plantaSelected.ipBalanza + " - " + this.plantaSelected.balanza },
      { etiqueta: 'ULTIMO PESO',  valor: this.lastPesajeDia ? this.lastPesajeDia.peso : 0.00 },
    ];
  }

  getPesajeInfo() {
    const balanzaId = this.plantaSelected.balanzaId;
    console.info("*** capturando peso para balanza *** ", this.plantaSelected.balanzaId, this.plantaSelected.balanza);

    this._basculasIoAPI.capturaPesaje(balanzaId).subscribe((res: any) => {
      //this.valorCaptura = res;
      this.formCaptura.get('pesaje').setValue(res.pesoGramos);
    }, (err) => {
      console.log('err',err);
      this._util.mensajeErroToast("No hay hisotrico de pesaje para la selección ",3000);
    });


  }

  saveCapturaPeso() {
    if (this.formCaptura.invalid) return this._util.alertifyToastWar("Formulario Invalido, revise sus datos");
    if (this.formCaptura.get('pesaje').value <= 0.00) return;
    this.loading = true;

    console.log("rowDAta", this.rowData);

    this.pesoCapturado            = this.formCaptura.getRawValue();
    this.pesoCapturado.basculaId  = this.plantaSelected.balanzaId;
    this.pesoCapturado.materialId = this.rowData['idProducto'];
    this.pesoCapturado.ordenProduccion = this.rowData['ordenProduccion'];
    this.pesoCapturado.lote       = this.rowData['noLote'];
    this.pesoCapturado.turno      = this.rowData['turno'];
    this.pesoCapturado.codigoEvento = this.rowData['codigoEvento'];
    this.pesoCapturado.peso       = Number(this.valorCaptura);
    
    const payload = this.pesoCapturado;
    console.log("paylod a enviar", payload);
    
    this._util.confirmarSincronoPromesa({
      title   : this.DAT_MSG.procesar,
      text    : `Guardar Pesaje : ${this.valorCaptura}`,
      action  : "Capturar Peso",
      funcion : this._basculasIoAPI.savePesaje(payload),
    }).then((res: any) => {
      this.loading = false;
      this.formCaptura.get('usuario').setValue(localStorage.getItem('userName'));
      this.formCaptura.get('peso').setValue(0);
      //this.lastPesajeDia.peso = Number(this.valorCaptura);
      this.closeModal();
    }).catch(() => {
      this.loading = false;
    });

  }

  getLastPesaje() {
    const fecha = this._util.getFechaGuion();

    this._basculasIoAPI.lastPesaje(this.plantaSelected.balanzaId, 
      this.plantaSelected.plantaId, this.lineaSelected.id, fecha).subscribe((res: any) => {
      this.lastPesajeDia = res;
    }, (err) => {
      console.log('err',err);
      this._util.mensajeErroToast("No hay hisotrico de pesaje para la selección ",3000);
    });

  }

  // Consultar Lineas Activas
  ejecutarIntervalo(){
    this.autoSaveInterval = setInterval(function(){
      this.getLineasXPlanta();
      this.getRegistros();
      console.log('Intervalo de consultas de líneasejecutado');
    }.bind(this), 54000);
  }

  /*
  detenerIntervalo() {
    clearInterval(this.autoSaveInterval);
    console.log('Intervalo detenido');
  }*/

  resetControl(){
    this.valorCaptura  = 0.00;
    this.lineaSelected = [];
    this.detalleEvento = [];
    this.formCaptura.reset();
    //this.formPlanta.reset();
  }

  // Escuchar eventos del teclado
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const target = event.target as HTMLElement;
    const isInput = ['INPUT', 'SELECT'].includes(target.tagName);
    console.log("Key press ", event.key, ` (${event.code})`);

    if (!isInput && event.code === 'Space') {
      console.log('BARRA ESPACIADORA --> KEYDOWN');
      this.getPesajeInfo();
    }

    if (event.code === 'NumpadEnter' && this.formCaptura.valid) {
      console.log('ENTER --> KEYDOWN');
      this.saveCapturaPeso();
      }
  }


  // registros para grafica
  getRegistros(){
    const fecha = this._util.getFechayHoraActual();

    this._basculasIoAPI.lastPesajeDiario(this.plantaSelected.balanzaId, 
      this.plantaSelected.plantaId, 
      this.lineaSelected.id, 
      fecha, 
      this.rowData['idProducto']).subscribe((res: BasculasCapturador[]) => {
      if(res){
        res.forEach(item => {
          this.listDataGrafico.push({fecha_hora: item.creadoDate, valor: item.peso});
        });
        console.log("registros para grafico", this.listDataGrafico);
      }
    }, (err) => {
      console.log('err',err);
    });

  }

}
